import styled from 'styled-components'

const BodyBenefits = styled.div`
  padding: 24px;
  @media (min-width: 992px) {
    padding: 45px 120px;
  }
  > a {
    @media (min-width: 992px) {
      min-width: 210px;
      width: fit-content;
      max-width: 244px;
      margin: 0 auto;
    }
  }
`

const ButtonBenefits = styled.a`
  display: flex;
  padding: 11px 32px;
  background: #00518E;
  border-radius: 8px;
  margin-bottom: 16px;
  color: #fff;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  justify-content: center;
  @media (min-width: 992px) {
    min-width: 210px;
    width: fit-content;
    max-width: 244px;
    margin: 0 auto;
  }

  &:hover {
    background: #1B2A68;
  }
`

const Wrapper = styled.div`
  @media (min-width: 992px) {
    display: flex;
    flex-direction: column;
    max-width: 1200px;
    margin: auto;
  }
`

export { BodyBenefits, ButtonBenefits, Wrapper }
